import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/hooks/use-auth";

const BUILD_PROFILE_FLAG_KEY = "ernest_build_profile_pending_v1";

const MobileDesktopOnlyNotice = () => {
  const { signOut } = useAuth();
  const navigate = useNavigate();

  // Set by OnboardingPage right before it navigates to /building-profile —
  // lets us greet a just-onboarded mobile user differently from a returning
  // one, since DashboardLayout never mounts the welcome/recap modal on mobile.
  const [justOnboarded] = useState(() => {
    try { return sessionStorage.getItem(BUILD_PROFILE_FLAG_KEY) === "1"; } catch { return false; }
  });

  useEffect(() => {
    if (!justOnboarded) return;
    try { sessionStorage.removeItem(BUILD_PROFILE_FLAG_KEY); } catch { /* ignore */ }
  }, [justOnboarded]);

  return (
    <div className="min-h-[100dvh] flex flex-col bg-[#f7f6f3]">
      <header className="h-16 px-6 flex items-center">
        <Link to="/">
          <img src="/ernest-wordmark.png" alt="ernest" className="h-[28px] ml-[-2px]" />
        </Link>
      </header>

      <div className="flex-1 flex flex-col items-center justify-center px-6 text-center">
        {justOnboarded ? (
          <>
            <h1 className="text-xl font-medium tracking-tight text-foreground mb-2">
              Your account is ready.
            </h1>
            <p className="text-sm text-muted-foreground max-w-xs">
              ernest works best on a bigger screen.
              <br />
              Switch to a laptop to start discovering communities.
            </p>
          </>
        ) : (
          <>
            <h1 className="text-xl font-medium tracking-tight text-foreground mb-2">
              ernest is better on a bigger screen.
            </h1>
            <p className="text-sm text-muted-foreground max-w-xs">
              Discovering and managing communities takes some room to breathe.
              <br />
              Switch to a laptop to keep going.
            </p>
          </>
        )}
      </div>

      <div className="pb-16 flex justify-center">
        <button
          onClick={async () => {
            await signOut();
            navigate("/login");
          }}
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <LogOut className="w-3.5 h-3.5" /> Log out
        </button>
      </div>
    </div>
  );
};

export default MobileDesktopOnlyNotice;
